// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchInput_search__3-eU1","clean":"SearchInput_clean__3M8wX"};